var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaravan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.482 73.4055L139.05 76.2H155.359V78.5463H128.441",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2298 78.7479C52.2142 78.7479 39.5211 78.7479 29.8438 78.7479V35.7C55.5515 35.7 107.794 35.7 111.101 35.7C115.234 35.7 136.103 62.8188 134.994 68.7669C133.885 74.715 130.054 78.7479 127.332 78.7479C126.127 78.7479 106.088 78.7479 83.0741 78.7479",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5021 47.5406H36.5847C35.8392 47.5406 35.2347 48.145 35.2347 48.8906V56.1786C35.2347 56.9242 35.8392 57.5286 36.5847 57.5286H47.5021C48.2477 57.5286 48.8521 56.9242 48.8521 56.1786V48.8906C48.8521 48.145 48.2477 47.5406 47.5021 47.5406Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5683 47.5406H69.6509C68.9053 47.5406 68.3009 48.145 68.3009 48.8906V56.1786C68.3009 56.9242 68.9053 57.5286 69.6509 57.5286H80.5683C81.3138 57.5286 81.9183 56.9242 81.9183 56.1786V48.8906C81.9183 48.145 81.3138 47.5406 80.5683 47.5406Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.405 48.1346C116.154 47.7632 115.736 47.5406 115.287 47.5406H92.8395C92.0934 47.5406 91.4895 48.145 91.4895 48.8906V56.1787C91.4895 56.9243 92.0934 57.5287 92.8395 57.5287H120.213C121.295 57.5287 121.937 56.3192 121.332 55.4227L116.405 48.1346ZM116.405 48.1346L116.779 47.8827",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0996 41.55H53.0996C52.354 41.55 51.7496 42.1544 51.7496 42.9V73.5C51.7496 74.2456 52.354 74.85 53.0996 74.85H62.0996C62.8452 74.85 63.4496 74.2456 63.4496 73.5V42.9C63.4496 42.1544 62.8452 41.55 62.0996 41.55Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6598 44.25H55.7995C55.0539 44.25 54.4495 44.8544 54.4495 45.6V54.7027C54.4495 55.4483 55.0539 56.0527 55.7995 56.0527H59.6598C60.4054 56.0527 61.0098 55.4483 61.0098 54.7027V45.6C61.0098 44.8544 60.4054 44.25 59.6598 44.25Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3031 84.7501C77.618 84.7501 80.3052 82.0628 80.3052 78.7479C80.3052 75.433 77.618 72.7457 74.3031 72.7457C70.9882 72.7457 68.3009 75.433 68.3009 78.7479C68.3009 82.0628 70.9882 84.7501 74.3031 84.7501Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5224 69.3078L24.2996 72.6765V78.9756H27.5224",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6593 63.0195H49.806M65.7347 63.0195H126.627",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8937 38.7779H109.166",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaravan);
export default __webpack_public_path__ + "static/media/caravan.2af0230f46594c9482bbd9d6ac563e8a.svg";
export { ForwardRef as ReactComponent };